import { createUseStyles } from 'react-jss';

export default createUseStyles({
  inputsGrid: {
    maxWidth: '1200px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '480px auto',
    gridGap: '0px 60px',

    '& > div:nth-of-type(n+3) div.form-group': {
      height: '0',
    },

    '& > div:nth-of-type(1) div.form-group:nth-of-type(1)': {
      marginTop: '84px',
    },

    '@media(max-width: 900px)': {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto',
      '& > div:nth-of-type(1) div.form-group:nth-of-type(1)': {
        marginTop: '50px',
      },
      '& > div:nth-of-type(2)': {
        gridRow: '3 / 4',
        marginTop: '30px',
      },
    }
  },

  mainHeader: {
    color: '#102131',
    fontSize: '22px',
    fontWeight: '600',
    marginTop: '12px',
  },

  header: {
    color: '#102131',
    fontSize: '20px',
    fontWeight: '600',
    marginTop: '12px',
  },

  subheader: {
    position: 'relative',
    top: '20px',
    color: '#102131',
    fontSize: '16px',
    fontWeight: '500',
    marginBottom: '40px',
  },

  subsectionHeader: {
    top: '20px',
    color: '#102131',
    fontSize: '16px',
    fontWeight: '500',
    marginBottom: '40px',
  },

  button: {
    marginTop: '48px',
    width: '180px',
    '@media(max-width: 900px)': {
      width: '100%',
    }
  },
});
